import { useQuery } from 'react-query';
import { coreService } from 'network-utils';

export const getQuizInfo = 'fetch-quiz-info';

export const useGetQuizInfo = (token: string, quizId: number) => {
    return useQuery([getQuizInfo, { token, quizId }], () => coreService.quizApi.quizInfo(token, quizId), {
        keepPreviousData: true,
        cacheTime: 0,
        enabled: !!token && !!quizId
    });
};
